import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { getReportsByUser } from "../../redux/actions/reportActions";

export default function Warning() {
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
  const [reportList, setReportList] = useState([]);

  useEffect(() => {
    loadReportsByUser();
  }, []);

  async function loadReportsByUser() {
    const accessToken = await getAccessTokenSilently();
    const reports = await dispatch(getReportsByUser(accessToken));
    setReportList(buildReportList(reports));
    console.log("getReports: ", reports);
  }

  function buildReportList(reports) {
    console.log(reports);
    return reports.map(report => (
      <li className="warning-item" key={report.id}>
        <div>
          Du bröt mot användarvillkoren när du{" "}
          {report.report_type === "event" ? (
            <span>
              skapade en händelse som inte går i linje med syftet med hemsidan.
              Händelsen är raderad.
            </span>
          ) : (
            <span>
              uppdaterade din profil på ett sätt som inte går i linje med syftet
              med hemsidan. Informationen på din profilsida är borttagen.
            </span>
          )}{" "}
        </div>
        {report.admin_reason && (
          <div className="comment">
            Kommentar från admin: <span>{report.admin_reason}</span>
          </div>
        )}
      </li>
    ));
  }

  return (
    <div className="warning">
      <ul className="warning-list">
        {reportList.length > 0 && (
          <>
            OBS!
            <ul>{reportList}</ul>
            <div>Vid upprepade incidenter kommer ditt konto bli spärrat.</div>
          </>
        )}
      </ul>
    </div>
  );
}
